import type { TFunction } from 'i18next'

import { AnchorType } from '@/shared/generated'

export const ANCHOR_STATUS = {
	APPROVED: 'approved',
	REJECTED: 'rejected',
	REVIEW: 'review',
} as const

export const ANCHORS_TYPES = [
	AnchorType.Bundle,
	AnchorType.Flat,
	AnchorType.Ladder,
	AnchorType.ProductSet,
	AnchorType.Size,
]

export const getAnchorsTypesChoices = (t: TFunction) => [
	{
		value: AnchorType.Bundle,
		label: t('app.bundle_anchor'),
		variant: 'epic',
	},
	{
		value: AnchorType.Flat,
		label: t('app.flat_anchor'),
		variant: 'info',
	},
	{
		value: AnchorType.Ladder,
		label: t('app.ladder_anchor'),
		variant: 'alert',
	},
	{
		value: AnchorType.ProductSet,
		label: t('app.product_set_anchor'),
		variant: 'warning',
	},
	{
		value: AnchorType.Size,
		label: t('app.size_anchor'),
		variant: 'success',
	},
]

const ANCHOR_TEMPLATE_TYPE_LABELS: [AnchorType, string][] = [
	[AnchorType.Flat, 'Flat'],
	[AnchorType.Size, 'Size'],
	[AnchorType.Bundle, 'Bundle'],
	[AnchorType.Ladder, 'Ladder'],
	[AnchorType.ProductSet, 'Product set'],
]

// Headers mirror the export column labels in po; the import endpoint accepts
// them verbatim, so an exported file and this template are interchangeable.
export const ANCHOR_IMPORT_TEMPLATE_COLUMNS: {
	field: string
	header: string
}[] = [
	{ field: 'sku', header: 'SKU' },
	{ field: 'sales_entity_id', header: 'Sales Entity' },
	{ field: 'optimization_group_id', header: 'Optimization Group' },
	...ANCHOR_TEMPLATE_TYPE_LABELS.flatMap(([type, label]) => [
		{ field: `${type}_source_family_id`, header: `${label} source family id` },
		{ field: `${type}_anchor_sku`, header: `${label} SKU` },
		{ field: `${type}_anchor_mul`, header: `${label} index` },
		{ field: `${type}_anchor_add`, header: `${label} +/-` },
	]),
]
